import React, { useState } from 'react';
import { useSubscription } from '../contexts/SubscriptionContext';

const SubscriptionGate: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const {
    subscriptionStatus,
    trialDaysRemaining,
    isReadOnly,
    redirectToCheckout,
  } = useSubscription();
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [trialBannerDismissed, setTrialBannerDismissed] = useState(false);

  const handleSubscribe = async () => {
    setCheckoutLoading(true);
    try {
      await redirectToCheckout();
    } catch {
      setCheckoutLoading(false);
    }
  };

  return (
    <>
      {/* Read-only banner for expired/canceled users */}
      {isReadOnly && (
        <div className="sticky top-0 z-40 bg-red-600 text-white px-4 py-3 flex items-center justify-between shadow-md">
          <p className="text-sm font-medium">
            {subscriptionStatus === 'expired'
              ? 'Twój okres próbny wygasł. Subskrybuj aby kontynuować korzystanie ze wszystkich funkcji.'
              : 'Twoja subskrypcja została anulowana. Odnów aby korzystać ze wszystkich funkcji.'}
          </p>
          <button
            onClick={handleSubscribe}
            disabled={checkoutLoading}
            className="ml-4 px-4 py-1.5 bg-white text-red-600 text-sm font-semibold rounded-md hover:bg-red-50 transition-colors disabled:opacity-50 whitespace-nowrap"
          >
            {checkoutLoading ? 'Przekierowanie...' : 'Subskrybuj'}
          </button>
        </div>
      )}

      {/* Trial warning banner (<7 days remaining) */}
      {subscriptionStatus === 'trial' &&
        trialDaysRemaining !== null &&
        trialDaysRemaining <= 7 &&
        !trialBannerDismissed && (
          <div className="sticky top-0 z-40 bg-amber-500 text-white px-4 py-3 flex items-center justify-between shadow-md">
            <p className="text-sm font-medium">
              {trialDaysRemaining === 0
                ? 'Twój okres próbny kończy się dzisiaj!'
                : trialDaysRemaining === 1
                  ? 'Został 1 dzień okresu próbnego.'
                  : `Pozostało ${trialDaysRemaining} dni okresu próbnego.`}
            </p>
            <div className="flex items-center gap-2 ml-4">
              <button
                onClick={handleSubscribe}
                disabled={checkoutLoading}
                className="px-4 py-1.5 bg-white text-amber-600 text-sm font-semibold rounded-md hover:bg-amber-50 transition-colors disabled:opacity-50 whitespace-nowrap"
              >
                {checkoutLoading ? 'Przekierowanie...' : 'Subskrybuj teraz'}
              </button>
              <button
                onClick={() => setTrialBannerDismissed(true)}
                className="p-1 hover:bg-amber-600 rounded transition-colors"
                aria-label="Zamknij"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        )}

      {children}
    </>
  );
};

export default SubscriptionGate;
